<template>
	<div class="row-fluid">
		<div class="span12 text-left" style="margin-bottom: 20px;">
			<div class="bg_voice">
				<img style="width: 100%; border-radius:10px;" src="https://img.hsnms.com/20220414/1649928311.jpg" />
			</div>
		</div>


		<div>
			<el-form ref="form" :model="form">
				<div style="margin-bottom: 2rem;">
					<div class="bt_hs1 tiaoti_a">单位名称</div>
					<el-input class="tiaoti_a_int" placeholder="请填写单位名称" v-model="form.company"></el-input>
				</div>
				<div style="margin-bottom: 2rem;">
					<div class="bt_hs1 tiaoti_a">职工人数</div>
					<el-input placeholder="请填写单位职工人数" v-model="form.number_a"></el-input>
				</div>
				<div style="margin-bottom: 2rem;">
					<div class="bt_hs1 tiaoti_a">负责人</div>
					<el-input placeholder="请填写单位负责人姓名" v-model="form.username"></el-input>
				</div>
				<div style="margin-bottom: 2rem;">
					<div class="bt_hs1 tiaoti_a">联系电话</div>
					<el-input placeholder="请填写单位负责人联系电话" v-model="form.telephone"></el-input>
				</div>

				<div style="margin-bottom: 2rem;">
					<div class="bt_hs1 tiaoti_a">详细地址</div>
					<el-input placeholder="请填写你公司的详细地址" v-model="form.address"></el-input>
				</div>

				<el-form-item style="margin-top: 30px; margin-bottom: 50px;">
					<el-button class="bin_tijiao" type="primary" @click="onSubmit">提交申请</el-button>
				</el-form-item>
			</el-form>


		</div>

		<div style="height: 20px;"></div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					company: '',
					number_a: 10,
					username: '',
					telephone: '',
					address: "",
					delivery: false,
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '申请入会'
					},
					{
						name: '2',
						label: '扫码入会'
					}
				]
			}
		},
		methods: {
			route1: function(myurl) {
				window.open(myurl, "_blank");
			},
			onSubmit() {
				if (this.form.company.length < 3 ||
					this.form.telephone.length < 3 ||
					this.form.username.length < 1 ||
					this.form.address.length < 3
				) {
					this.$Message.error("数据内容不能为空！")
					return
				}
				var openid=this.$route.query.openid;
				let data = new FormData()
				data.append('title', this.form.company)
				data.append('company', this.form.company)
				data.append('telephone', this.form.telephone)
				data.append('openid', openid)
				data.append('username', this.form.username)
				data.append('telephone', this.form.telephone)
				data.append('address', this.form.address)
				data.append('state', 3)

				this.$api.postAPI(
					"mutual/organization/?type_id=2022040016&state=1&redis_time=2&openid="+openid,
					data).then(res => {
					if (res.data.code == 200) {
						this.$Message.success("数据提交成功，等待审核！")
						console.log(res);
					}
				});

			},
			handleClick(tab) {
				console.log(tab)
			}
		}
	}
</script>

<style>
	.t_b .col-3 .b_t_5 {
		margin-top: 5px;
	}

	.t_b .col-3 {
		margin-top: 10px;
	}


	.bin_tijiao {
		height: 50px;
		width: 100%;
		font-size: 16px
	}

	.tiaoti_a {
		margin-bottom: .5rem;
		font-size: 16px
	}

	.el-tabs__item {
		font-size: 18px !important;
	}

	.tiaoti_a_int {
		font-size: 16px;
	}

	.el-input__inner {
		padding-left: 10px !important;
		height: 45px !important;
		line-height: 45px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/sqjh.vue